module.exports = __webpack_public_path__ + "static/media/1560446114995522663307.4bc7cf78.jpg";